import { pathOr } from 'ramda';
import * as React from 'react';

import { Windows } from '../../../components/advancedFilters/Windows';
import { EWindowsType } from '../../../types/jsonQuery';
import { useContext } from '../../../utils/useContext';

export const WindowsContainer: React.FC = () => {
  const { onChange, jsonQuery } = useContext();
  const windows = pathOr<EWindowsType | null>(null, ['windows_type', 'value'], jsonQuery);

  const handleChange = React.useCallback(
    (windows: EWindowsType | null) => {
      onChange({ action: 'setWindowsType', arguments: [windows] });
    },
    [onChange],
  );

  return <Windows value={windows} onChange={handleChange} />;
};
